import {Redirect, Route, Switch} from "react-router-dom";
import {getAuth, onAuthStateChanged} from "firebase/auth";
import AdminLayout from "./layouts/Admin";
import AuthLayout from "./layouts/Auth";
import AssessmentLayout from "./layouts/Assessment";
import React, {useEffect, useState} from "react";
import {Spinner} from "reactstrap";
import {getDb, trackGA4Event} from "./util/Constants";
import {doc, getDoc, updateDoc} from "firebase/firestore";
import CandidateFlow from "./layouts/CandidateFlow";
import {NotificationContainer} from "react-notifications";
import "react-notifications/lib/notifications.css";

const App = () => {
    const [signedInUser, setSignedInUser] = useState(getAuth().currentUser);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [metadata, setMetadata] = useState({});
    const [routeState, setRouteState] = useState("");
    const db = getDb();

    useEffect(() => {
        getMetadata().then(result => {
            setMetadata(result);
            console.log(result, "results");
            onAuthStateChanged(getAuth(), async (user) => {
                if (user) {
                    console.log(user);
                    if (user.emailVerified || user.email === "super.admin@activ8games.com" || user.email === "usama@gmail.com") {
                        console.log("111")
                        let _user = user;
                        const adminsRef = doc(db, "admins", user.uid);
                        const adminSnap = await getDoc(adminsRef);
                        if (adminSnap.exists()) {
                            if (!adminSnap.data().emailVerifired) {
                                trackGA4Event("email Verified", user.email, result.environment)
                                await updateDoc(adminsRef, { emailVerifired: true });
                            }
                            _user = { ..._user, ...adminSnap.data() };
                        } else {
                            _user.role = "admin";
                        }
                        localStorage.setItem('progressUser', JSON.stringify({ ..._user }));
                        setSignedInUser(_user);
                        
                        console.log(_user, "App.js USer");
                        setIsLoggedIn(true);
                    } else {
                        setSignedInUser(null);
                        setIsLoggedIn(false);
                    }
                } else {
                    setSignedInUser(null);
                    setIsLoggedIn(false);
                }
                console.log("11")
                setIsLoading(false);
            });
        })
    }, []);


    const getMetadata = async () => {
        const utilsRef = doc(db, "util", "meta");
        const utilSnap = await getDoc(utilsRef);
        if (utilSnap.exists()) {
            console.log(utilSnap.data());
            return utilSnap.data()
        }
    }

    return (<>
        {isLoading ? <div className="text-center mt-7">
            <Spinner
                color={'primary'}
                size={''}
            >
                Loading...
            </Spinner>
        </div> : <>
            <Switch>
                {/*<Route path="/easy-flow" render={props => {*/}
                {/*    if (signedInUser) return <UserLayout {...props} signedInUser={signedInUser}*/}
                {/*                                         eventData={getEventsofUser}/>;*/}
                {/*    return <Redirect to="/auth/login"/>*/}
                {/*}}/>*/}
                <Route path="/assessment" render={props => {
                    if (signedInUser) return <AssessmentLayout {...props} signedInUser={signedInUser}
                                                               metadata={metadata}/>;
                    return <Redirect to="/auth/login"/>
                }}/>
                <Route path="/candidate-flow/:id" render={props => {
                    return <CandidateFlow metadata={metadata}/>
                }}/>
                <Route path="/admin" render={props => {
                    setRouteState(props.location.pathname);
                    if (signedInUser) {
                        return <AdminLayout {...props} signedInUser={signedInUser} setRouteState={setRouteState}
                                            metadata={metadata}/>;
                    }
                    return <Redirect to="/auth/login"/>
                }}/>
                <Route path="/auth" render={props => {
                    if (!signedInUser) return <AuthLayout {...props} signedInUser={signedInUser}
                                                          metadata={metadata}/>;
                    return signedInUser.role === 'superAdmin' ?
                        <Redirect to="/admin/accounts"/> : signedInUser.role === 'admin' && signedInUser.newUser ?
                            <Redirect to="/assessment/index"/> : <Redirect to={routeState}/>
                }}/>
                <Redirect from="/"
                          to={signedInUser?.role === 'superAdmin' ? '/admin' : signedInUser?.newUser ? 'assessment/index' : '/assessment/dashboard'}/>
            </Switch>
            <NotificationContainer/>
        </>}
    </>)
}

export default App;